import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import { Fragment } from "react";
import styled from "styled-components";

import { CaseAdmin, CaseQAReview } from "pwapi";

const NoteList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: -0.5em;
`;

const Note = styled.li`
  display: flex;
  flex-wrap: wrap;
  padding: 0.5em;
`;

const NoteHeader = styled.div`
  display: flex;
  flex: 1 1 100%;
  gap: 0.5em;
  align-items: center;
`;

const NoteContent = styled.div`
  margin-left: 3em;
  font-style: italic;
`;

export const sortByLatest = (qaReviews: CaseQAReview[] | undefined) => {
  return [...(qaReviews || [])].sort((a, b) =>
    (a.created_at || "") < (b.created_at || "") ? -1 : 1
  );
};

const ReviewList = ({
  reviews = [],
}: {
  reviews?: CaseAdmin["qa_reviews"];
}) => (
  <NoteList>
    {reviews.map((review) => (
      <Note key={review.id}>
        <NoteHeader>
          <FontAwesomeIcon
            icon={
              review.reviewed === null
                ? "comment"
                : review.reviewed
                ? "circle-check"
                : "circle-xmark"
            }
            color={
              review.reviewed === null
                ? "var(--steel)"
                : review.reviewed
                ? "var(--green)"
                : "var(--red)"
            }
            fontSize={20}
          />
          <span>
            {review.created_at
              ? DateTime.fromISO(review.created_at).toLocaleString(
                  DateTime.DATETIME_SHORT
                )
              : ""}{" "}
            {review.user
              ? `${review.user.first_name} ${review.user.last_name}`
              : ""}
            :{" "}
            {review.reviewed === null
              ? ""
              : review.reviewed
              ? "Completed a QA review"
              : "Held the case"}
          </span>
        </NoteHeader>
        {review.note && (
          <NoteContent>
            {review.note.split("\n").map((s, i, r) => (
              <Fragment key={`${s}${i}`}>
                {s}
                {i + 1 !== r.length && <br />}
              </Fragment>
            ))}
          </NoteContent>
        )}
      </Note>
    ))}
  </NoteList>
);

export default ReviewList;
